module.exports = {"Type":"ResetVars","Fields":[{"label":"Variables to reset","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"cornflowerblue","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/ResetVars.json
// module id = 703
// module chunks = 0